import { useEffect, useState } from 'react'

// Liefert `value` erst nach, wenn er `delay` ms lang unveraendert blieb. Eine
// Suche, die bei jeder Eingabe mitlaeuft, fragt so nicht je Taste den Server.
const useDebouncedValue = (value, delay) => {
    const [debounced, setDebounced] = useState(value)

    useEffect(() => {
        const timer = setTimeout(() => setDebounced(value), delay)
        return () => clearTimeout(timer)
    }, [value, delay])

    return debounced
}

export default useDebouncedValue
